export const copyToClippboard = input => {
  const el = document.createElement('input')
  el.value = input
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
